// extracted by mini-css-extract-plugin
export default {"fileSelected":"FileItem_fileSelected__i4Hir","actionButtons":"FileItem_actionButtons__A7lq1"};